module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "context-info-modal",
      "draggable": true,
      "resizable": true,
      "minWidth": 250,
      "minHeight": 220
    },
    on: {
      "closed": _vm.resetState
    }
  }, [_c('div', {
    staticClass: "context-info-modal"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.closeByName
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.showDownloadLinks) ? _c('div', {
    staticClass: "context-info-modal-download-links"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.layerInfo.label))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.requestEmailChange
    }
  }, [_vm._v(_vm._s(_vm.$t('contextInfoModal.changeEmailLabel')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tbody', _vm._l((_vm.downloadLinksIntl), function(downLink) {
    return _c('tr', {
      key: downLink.url
    }, [_c('td', [_c('a', {
      attrs: {
        "href": downLink.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      on: {
        "click": function($event) {
          return _vm.processDownloadLink(downLink)
        }
      }
    }, [_vm._v(_vm._s(downLink.label))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.showEmailPrompt) ? _c('div', {
    staticClass: "context-info-modal-email-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("contextInfoModal.emailTitle")))]), _vm._v(" "), _c('input', {
    class: {
      invalid: _vm.emailInvalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "change": _vm.changeEmail
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.validateEmailAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t("contextInfoModal.submitDataLabel")))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7445036b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContextInfoModal.vue
// module id = 636
// module chunks = 2